/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TimeClockIcon16Light } from './TimeClockIcon16Light';
import { TimeClockIcon16Regular } from './TimeClockIcon16Regular';
import { TimeClockIcon16Solid } from './TimeClockIcon16Solid';
import { TimeClockIcon20Light } from './TimeClockIcon20Light';
import { TimeClockIcon20Regular } from './TimeClockIcon20Regular';
import { TimeClockIcon20Solid } from './TimeClockIcon20Solid';
import { TimeClockIcon24Regular } from './TimeClockIcon24Regular';
import { TimeClockIcon24Solid } from './TimeClockIcon24Solid';
import { TimeClockIcon32Regular } from './TimeClockIcon32Regular';
import { TimeClockIcon64Regular } from './TimeClockIcon64Regular';
var sizes = {
    16: {
        light: TimeClockIcon16Light,
        regular: TimeClockIcon16Regular,
        solid: TimeClockIcon16Solid,
    },
    20: {
        light: TimeClockIcon20Light,
        regular: TimeClockIcon20Regular,
        solid: TimeClockIcon20Solid,
    },
    24: {
        regular: TimeClockIcon24Regular,
        solid: TimeClockIcon24Solid,
    },
    32: {
        regular: TimeClockIcon32Regular,
    },
    64: {
        regular: TimeClockIcon64Regular,
    },
};
export var TimeClockIcon = forwardRef('TimeClockIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
